import { Text, Box, Stack, Icon, Button } from "components"
import React, { Component, ErrorInfo, ReactNode } from "react"
import { Translation } from "react-i18next"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * return fallback error page
 */
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("Uncaught error:", error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Box height="100vh" width="100%" justifyContent="center" alignItems="center">
          <Stack spacing="10px" alignItems="center" vertical>
            <Icon color="coral" size="302px" name="crisis_alert" />
            <Translation>
              {(t) => (
                <Stack vertical alignItems="center" spacing="25px">
                  <Text color="coral" variant="h1">
                    {t("general.error", "Something went wrong.")}
                  </Text>
                  <Button onClick={() => window.location.reload()} fullWidth variant="important">
                    {t("general.retry", "Retry")}
                  </Button>
                </Stack>
              )}
            </Translation>
          </Stack>
        </Box>
      )
    }

    return this.props.children
  }
}
